import { Heading as DotHeading, ModalBody as DotModalBody, ModalContent as DotModalContent } from '@dot/design-system';
import { default as styled } from 'styled-components';

import { fontTextSmRegular } from '@/styles/helpers';

export const ModalContent = styled(DotModalContent)`
  height: auto;
  max-width: 570px;
  border-radius: 16px;
  padding: 32px;
  position: absolute;
  top: 50%;

  left: 5%;
  right: 5%;
  transform: translate(0, -50%);

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
  }
`;

export const ModalBody = styled(DotModalBody)`
  text-align: center;
`;

export const IconWrapper = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: center;

  & > svg {
    width: 64px;
    height: 64px;
    color: ${(p) => p.theme.colors.oxfordBlue[30]};
    display: block; /* NOTE: to avoid extra space below the svg */
  }
`;

export const Heading = styled(DotHeading)`
  margin-bottom: 0.5rem;
`;

export const Text = styled.p`
  ${fontTextSmRegular};
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;

  flex-direction: column-reverse;
  margin-top: 16px;

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    flex-direction: row;
    margin-top: 20px;
  }
`;
